<template>
  <div class="create-user">
    <div
      id="createUserModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="card">
            <form @submit="addUser">
              <div class="card-header border-6 bg-gray-300">
                <h4><i class="fa fa-user-alt" />Create User</h4>
              </div>

              <div class="card-body">
                <div
                  class="form-group row"
                  :class="{'has-error': errorCreateUser.employee_id !== ''}"
                >
                  <div class="form-group col-sm-4">
                    <label
                      for="employeeid"
                      class="font-weight-bolder"
                    >Employee Id</label>
                    <input
                      v-model="newUser.employee_id"
                      @input="capitalize($event, newUser, 'employee_id')"
                      type="text"
                      class="form-control font-weight-bold"
                      id="employeeid"
                      placeholder="Employee Id"
                      style="font-size: 0.8em;"
                    >
                    <span
                      class="help-block"
                      v-if="errorCreateUser.employee_id !== ''"
                    >
                      <small><strong>{{ errorCreateUser.employee_id }}</strong></small>
                    </span>
                  </div>
                </div>

                <div class="form-group row">
                  <div
                    class="form-group col-md-4"
                    :class="{'has-error':errorCreateUser.last_name !== ''}"
                  >
                    <label
                      for="lastname"
                      class="font-weight-bolder"
                    >Lastname</label>
                    <input
                      v-model="newUser.last_name"
                      @input="capitalize($event, newUser, 'last_name')"
                      type="text"
                      class="form-control font-weight-bold"
                      id="lastname"
                      placeholder="Lastname"
                      style="font-size: 0.8em;"
                    >
                    <span
                      class="help-block"
                      v-if="errorCreateUser.last_name !== ''"
                    >
                      <small><strong>{{ errorCreateUser.last_name }}</strong></small>
                    </span>
                  </div>


                  <div
                    class="form-group col-md-4"
                    :class="{'has-error': errorCreateUser.name !== ''}"
                  >
                    <label
                      for="firstname"
                      class="font-weight-bolder"
                    >Firstname</label>
                    <input
                      v-model="newUser.name"
                      @input="capitalize($event, newUser, 'name')"
                      type="text"
                      class="form-control font-weight-bold"
                      id="firstname"
                      placeholder="Firstname"
                      style="font-size: 0.8em;"
                    >

                    <span
                      class="help-block"
                      v-if="errorCreateUser.name !== ''"
                    >
                      <small><strong>{{ errorCreateUser.name }}</strong></small>
                    </span>
                  </div>

                  <div
                    class="form-group col-md-4"
                    :class="{'has-error': errorCreateUser.middle_name !== ''}"
                  >
                    <label
                      for="middlename"
                      class="font-weight-bolder"
                    >Middlename</label>
                    <input
                      v-model="newUser.middle_name"
                      @input="capitalize($event, newUser, 'middle_name')"
                      type="text"
                      class="form-control font-weight-bold"
                      id="middlename"
                      placeholder="Middlename"
                      style="font-size: 0.8em;"
                    >
                    <span
                      class="help-block"
                      v-if="errorCreateUser.middle_name !== ''"
                    >
                      <small><strong>{{ errorCreateUser.middle_name }}</strong></small>
                    </span>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{'has-error': errorCreateUser.address !== ''}"
                >
                  <label
                    for="inputAddress"
                    class="font-weight-bolder"
                  >Address</label>
                  <input
                    v-model="newUser.address"
                    @input="capitalize($event, newUser, 'address')"
                    type="text"
                    class="form-control font-weight-bold"
                    id="inputAddress"
                    placeholder="1234 Main St"
                    style="font-size: 0.8em;"
                  >

                  <span
                    class="help-block"
                    v-if="errorCreateUser.address !== ''"
                  >
                    <small><strong>{{ errorCreateUser.address }}</strong></small>
                  </span>
                </div>

                <div class="form-row">
                  <!-- username -->
                  <div
                    class="form-group col-md-4"
                    :class="{'has-error': errorCreateUser.username !== ''}"
                  >
                    <label
                      for="userUsername"
                      class="font-weight-bolder "
                    >Username</label>
                    <input
                      v-model="newUser.username"
                      @input="capitalize($event, newUser, 'username')"
                      type="text"
                      id="userUsername"
                      name="userUsername"
                      class="form-control font-weight-bold"
                      placeholder="Username"
                      style="font-size: 0.8em;"
                    >

                    <span
                      class="help-block"
                      v-if="errorCreateUser.username !== ''"
                    >
                      <small><strong>{{ errorCreateUser.username }}</strong></small>
                    </span>
                  </div>

                  <!-- username -->
                  <div
                    class="form-group col-md-4"
                    :class="{'has-error': errorCreateUser.password !== ''}"
                  >
                    <label
                      for="userPassword"
                      class="font-weight-bolder"
                    >Password</label>

                    <div class="inner-addon right-addon">
                      <i
                        class="fa fa-eye icon"
                        @click="showPassword"
                      />
                      <input
                        v-model="newUser.password"
                        @input="capitalize($event, newUser, 'password')"
                        type="password"
                        id="userPassword"
                        name="userPassword"
                        class="form-control input-field font-weight-bolder"
                        placeholder="Password"
                        maxlength="40"
                        style="font-size: 0.8em;"
                      >

                      <span
                        class="help-block"
                        v-if="errorCreateUser.password !== ''"
                      >
                        <small><strong>{{ errorCreateUser.password }}</strong></small>
                      </span>
                    </div>
                  </div>

                  <div
                    class="form-group col-md-4"
                    :class="{'has-error': errorCreateUser.email !== ''}"
                  >
                    <label
                      for="email"
                      class="font-weight-bolder"
                    >Email</label>
                    <div class="input-icons">
                      <input
                        v-model="newUser.email"
                        @input="capitalize($event, newUser, 'email')"
                        type="email"
                        id="email"
                        name="username"
                        class="form-control font-weight-bold input-field create-user"
                        placeholder="Email"
                        maxlength="50"
                        style="font-size: 0.7em;"
                      >

                      <span
                        class="help-block"
                        v-if="errorCreateUser.email !== ''"
                      >
                        <small><strong>{{ errorCreateUser.email }}</strong></small>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- status-->
                <div class="form-row">
                  <!-- user type -->
                  <div class="form-group col-md-4">
                    <label
                      for="userType"
                      class="font-weight-bolder"
                    >User Type</label>
                    <select
                      id="userType"
                      class="form-control font-weight-bold"
                      style="font-size: 0.8em;"
                      v-model="newUser.user_type_id"
                    >
                      <option
                        selected
                        disabled
                      >
                        Choose...
                      </option>
                      <option
                        class="font-weight-bold"
                        v-for="userType in userTypes"
                        :key="userType.id"
                        :value="userType.id"
                      >
                        {{ userType.name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group col-md-2">
                    <label
                      for="status"
                      class="font-weight-bolder"
                    >Status :</label>
                    <input
                      type="checkbox"
                      name="status"
                      id="status"
                      class="form-control create-user"
                      v-model="newUser.status"
                    >
                  </div>

                  <div class="col-md-2 col-form-label font-weight-bold">
                    <label>{{ newUser.status ? 'ACTIVE':'INACTIVE' }}</label>
                  </div>
                </div>
              </div>

              <div class="card-footer bg-gray-300">
                <div class="text-right">
                  <button
                    type="submit"
                    class="btn btn-success btn-sm"
                  >
                    Create
                  </button>&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { formMixins } from "../../../mixins/formMixins";

    export default {
        mixins: [formMixins],
        name: 'CreateUsers',
        data() {
            return {

            }
        },

        methods: {
            ...mapActions(['createUser','getAllUserTypes']),
            async addUser(e) {
                e.preventDefault();
                if(await this.confirmCreateAlert('Are you sure you want to add this new record.','CREATE')){
                    this.createUser(this.newUser);
                }
            },

            showPassword() {
                let x = document.getElementById("userPassword");
                if(x.type === "password"){
                    x.type = "text";
                } else {
                    x.type = "password";
                }
            }
        },

        computed: {
            ...mapGetters([
                'newUser',
                'errorCreateUser',
                'userTypes'
            ]),
        },

        created() {
            this.getAllUserTypes();
        },
    };
</script>

<style scoped>
    .form-check-input {
        height: 20px;
        width: 20px;
    }


    .inner-addon {
        position: relative;
    }

    /* style icon */
    .inner-addon .fa {
        position: absolute;
        padding: 10px;
        /*pointer-events: none;*/
    }

    /* align icon */
    .left-addon .fa  { left:  0px;}
    .right-addon .fa { right: 0px;}

    /* add padding  */
    .left-addon input  { padding-left:  30px; }
    .right-addon input { padding-right: 30px; }

    .input-field {
        width: 100%;
        padding: 10px;
        text-align: center;
    }

   /* .input-icons i {
        position: absolute;
        text-align: right;
    }

    .input-icons {
        width: 100%;
        margin-bottom: 10px;
    }

    .icon {
        padding: 10px;
        !*padding-left: 200px;*!

        min-width: 40px;
    }

    .input-field {
        width: 100%;
        padding: 10px;
        text-align: center;
    }*/
</style>
